module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-01-acdf2658c37b8d7f6b8b04a4ec80052b.jpg";